export interface IPunchSetApproval {
    ApprovedDateTime: string | Date
    ApproverUserId: string
    ApproverName: string
    Base64SignatureString: string
    SignatureImageS3Url: string
    SignatureImageID: string
    SignatureDateTime: string | Date
    Title: string
}
export enum EPunchSetApprovalType {
    Supervisor = 0,
    Employee = 1,
    ExtSupervisor = 2
}